var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNpNepal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_21542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4287 44.4287H26.1357L47.9238 22.333L25.3096 22.3594L59.4199 0.571289V44.4287H59.4287Z",
    fill: "#CE0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0264 -0.535645L23.2298 22.9683L46.4725 22.9412L24.686 45.0352H59.4287V44.4287H60.0264V-0.535645ZM58.8135 43.8223H27.5854L49.3752 21.7249L27.3894 21.7505L58.8135 1.6783V43.8223Z",
    fill: "#000063"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1182 32.6777L46.4912 33.4687L44.6279 35.209L47.1328 35.0508L46.1045 37.3535L48.3457 36.2725L48.3018 38.7861L49.9541 36.9492L50.8945 39.2871L51.7031 36.9756L53.4873 38.7861L53.3291 36.3516L55.6934 37.3535L54.5859 35.1562L57.1611 35.209L55.2715 33.6006L57.6709 32.6777L55.2979 31.8867L57.1699 30.1465L54.6738 30.3047L55.6934 28.002L53.4434 29.083L53.4873 26.5693L51.835 28.4063L50.8945 26.0684L50.0947 28.3799L48.3018 26.5693L48.4688 29.0039L46.0957 28.002L47.2119 30.1992L44.6279 30.1465L46.5176 31.7549L44.1182 32.6777ZM46.9658 16.4443L47.959 17.1826L47.4668 17.5869C46.3118 16.7801 45.3828 15.6908 44.7686 14.4229C44.6104 16.2949 46.3242 20.4873 50.8066 20.5313C51.6259 20.5417 52.4392 20.3898 53.1994 20.0843C53.9597 19.7788 54.6519 19.3257 55.2362 18.7513C55.8204 18.1769 56.2851 17.4924 56.6034 16.7374C56.9218 15.9824 57.0874 15.1719 57.0908 14.3525C56.2119 15.9521 55.667 16.7256 54.2783 17.5605L53.8652 17.1738L54.7969 16.3916L53.5928 16.0752L54.2432 14.9854L52.9775 15.0732L53.1357 13.8076L52.0283 14.458L51.6768 13.2715L50.8857 14.2207L50.1387 13.3154L49.7344 14.5459L48.6973 13.8252L48.8291 15.082L47.5811 14.9326L48.1699 16.0928L46.9658 16.4443Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_21542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpNepal);
export default __webpack_public_path__ + "static/media/np Nepal.700670610255ab5ffac92a7b5503f7ff.svg";
export { ForwardRef as ReactComponent };